import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';
import { getUser } from "./../../../actions/auth-actions";
import {initialErrors, fieldValidation  } from '../../common/helper/form-constants.js';
import ConfigService from "../../../services/config-service.js";
import UserService from "../../../services/user-service.js";
import Alert from '../../common/modals/alert.component.js';
import { FormField, SelectField } from './../../common/helper/formFields';


const UpdateProfile = () => { 
  const [loading, setLoading] = useState(false);
  const [formData,setFormData] = useState({});
  const userData = useSelector(state => state.authReducer);
  const [errors, setErrors] = useState({ ...initialErrors });
  const gender = [{ label : 'Male', value : 'M'},{label : 'Female',value : 'F'}]
  const [formDataPersonal, setFormDataPersonal] = useState({ });
  const [statesData, setStatesData] = useState([]);
  const [city,setCity] = useState([]);
  const [passwordChange, setPasswordChange] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordCurrent, setShowPasswordCurrent] = useState(false);

  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [role,setUserRole] = useState();
  const dispatch = useDispatch();
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const togglePasswordVisibilityCurrent = () => {
    setShowPasswordCurrent(!showPasswordCurrent);
  };
  const togglePasswordVisibilityconfirm = () => {
    setShowPasswordConfirm(!showPasswordConfirm);
  };
  const getStates = () => {
    setLoading(true);
    ConfigService.getStates()
      .then(response => {
        const states =  response.data.data.map(state => ({ value: state.id, label: state.state }));
        setStatesData(states);
        getCities(userData.user.data.address.state_id);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  }
  const getCities = (stateID, data=null) => {
    setLoading(true);
    ConfigService.getCities(stateID)
      .then(response => {
        const cities =  response.data.data.map(city => ({ value: city.id, label: city.city }));
        setCity(cities)
        setAddressInfo();
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  }


  const setAddressInfo = () => {
    const data = userData.user.data
    const address = {
        addressLine1: data.address.address1,
        addressLine2: data.address.address2,
        city: data.address.city_id,
        state: data.address.state_id,
        postalCode: data.address.zip
    }
    setFormDataPersonal(address);
  }
  const updateBasic = (userData) => {
    let formattedDateOfBirth;
    const inputDate = userData.date_of_birth; 
    if(inputDate) {
      const parts = inputDate.split('-');
    formattedDateOfBirth = `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    //onst parts = inputDate.split('-');
    //const formattedDateOfBirth = `${parts[2]}-${parts[1]}-${parts[0]}`;
    const data = {
      "fullName": userData.full_name,
      "email": userData.email_address,
      "phoneNumber": userData.mobile_number,
      "datofBirth": formattedDateOfBirth,
      "gender": userData.gender_id,
      "nationalID": userData.national_id || '',
      "agentID" : userData.agent_id
    }
    setFormData(data)
  }
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  }
  const validateField = (fieldName, value) => {
    let errorMessage = fieldValidation(fieldName, value);
    if (fieldName === 'confirm_password') {
    if (value && value !== passwordChange.new_password) {
      errorMessage = 'Password and confirm password not matched';
    } 
  }
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
  };
  const handleChangeAddress = (e) => {
    const { name, value } = e.target;
    setFormDataPersonal((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
    if (name === 'state') {
      getCities(value);
    }
  }

  const handleChangePassword = (e) => {
    const { name, value } = e.target;
    setPasswordChange((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
    // if (name === 'newPassword') {
    //   validateField('confirmationPassword', passwordChange.confirmationPassword);
    // }
  }

  const updateBasicInfo = (e) => {
    e.preventDefault();
    
    Object.keys(formData).forEach((fieldName) => validateField(fieldName, formData[fieldName]));
    const hasErrors = Object.entries(formData).some(([key, value]) => {
        if (key === "nationalID") return false;
        return value === '';
    });
    if(!hasErrors){
      let formattedDateOfBirth;
      const userId = userData.user.data.user_id
        setLoading(true);
        const inputDate = formData.datofBirth; 
        if(inputDate) {
          const parts = inputDate.split('-');
        formattedDateOfBirth = `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
        
        const dataToupdate = {
          "profile_detail" : {
            "full_name": formData.fullName,
            "user_id": userId,
            "email_address": formData.email,
            "mobile_number": formData.phoneNumber,
            "date_of_birth": formattedDateOfBirth,
            "gender_id": formData.gender,
            "national_id": formData.nationalID,
            }
          }
          updateUserProfile(dataToupdate)
        }
  }

  const updateAddress = (e) => {
    e.preventDefault();
    const hasErrors =  Object.values(formDataPersonal).some(value => value === '');
        if(!hasErrors){
            const dataToupdate = {
                address_detail:{
                    address1: formDataPersonal.addressLine1,
                    address2: formDataPersonal.addressLine2,
                    city_id:formDataPersonal.city,
                    state_id: formDataPersonal.state,
                    zip: formDataPersonal.postalCode,
                }
            }
            updateUserProfile(dataToupdate)
          }
  }

  const updateUserProfile = (data) => {
    UserService.updateUserProfile(data)
          .then(response => {
            setLoading(false);
            dispatch(getUser())
            toast.success(MESSAGES.PRF_UPDATED)
          })
          .catch(error => {
            setLoading(false);
            try {
              const errorMessage = error.response.data
              toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
            } catch (e){
              toast.error( MESSAGES.SERVER_ERROR)
            }
          });
  }
  const validateFields = (fields, formData) => {
    let isValid = true;
    fields.forEach(fieldName => {
      const fieldValue = formData[fieldName];
      if (!fieldValue || !fieldValue.trim()) {
        validateField(fieldName, fieldValue || ''); 
        isValid = false;
      }
    });
    return isValid;
  };
  const updatePassword = (e) => {
    e.preventDefault()
    const requiredFields = ['current_password', 'new_password', 'confirm_password'];
    if (!validateFields(requiredFields, passwordChange)) return;
    const hasErrors =  Object.values(passwordChange).some(value => value === '');
    if(!hasErrors) {
      setLoading(true);
      UserService.changePassword(passwordChange)
      .then(response => {
        setLoading(false);
        toast.success(MESSAGES.PWD_CHNG)
        setModalShow(true);
      })
      .catch(error => {
        setLoading(false);
        try {
          const errorMessage = error.response.data
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
        } catch (e){
          toast.error( MESSAGES.SERVER_ERROR)
        }
      });
    }
    
  }
  const logout = () => {
    setModalShow(false);
    LoginService.deleteAccessToken();
   // toast.success('logged out successfully.')
  }

    useEffect(() => {
      updateBasic(userData.user.data);
      setUserRole(userData.user.data.role.role_code.toLowerCase())
      getStates();
        document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
}, []);

function getCurrentDate() {
  const today = new Date();
  const year = today.getFullYear();
  let month = today.getMonth() + 1;
  let day = today.getDate();

  if (month < 10) {
      month = '0' + month;
  }
  if (day < 10) {
      day = '0' + day;
  }

  return `${year}-${month}-${day}`;
}
return (
<>
    <LoaderOverlay loading={loading} />
    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
      <h4 className="updatename" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Update Profile</h4>
      <div className="container" style={{backgroundColor: 'white'}}>
        <nav>
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            <button className="nav-link active tbbtn" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Basic Information</button>
            <button className="nav-link tbbtn" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false" onclick="myFunction()" tabIndex={-1}>Address</button>
            <button className="nav-link tbbtn" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false" onclick="myFunctiosn()" tabIndex={-1}>Change Password</button>
          </div>
        </nav>
        <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px'}}>
          <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
            <form onSubmit={updateBasicInfo}>
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="col-md-12" style={{padding: 0}}>
                  
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                  {role == 'agent' && (
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    {/* <label htmlFor="f_name">AGENT ID</label>
                    <input type="text" className="form-control" id="first_name" defaultValue={2222252524} name="f_name" disabled /> */}
                    <FormField
                        type="text"
                        isRequierd = {false}
                        id="agentID"
                        name="agentID"
                        label="AGENT ID"
                        placeholder = "Enter Agent ID"
                        
                        disabled={true.toString()}
                        value={formData.agentID}
                        maxLength={20}
                      />
                  </div>
                  )}
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {true}
                           id="f_name"
                           name="fullName"
                           label="FULL NAME"
                           placeholder = "Enter Full Name"
                           value={formData.fullName}
                           onChange={handleChange}
                           error={errors.fullName}
                           
                           
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {true}
                           id="email"
                           name="email"
                           label="EMAIL"
                           placeholder = "Enter email"
                           value={formData.email}
                           onChange={handleChange}
                           error={errors.email}
                           disabled={true}
                        />
                    </div>
                    {role != 'agent' && (
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <SelectField 
                                id="gender"
                                isRequierd = {true}
                                name="gender"
                                label="GENDER"
                                selectedField = "Select Gender"
                                value={formData.gender}
                                onChange={handleChange}
                                error={errors.gender}
                                options={gender}
                                />
                    </div>
                    )}
                    {/* {role != 'agent' && (
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">UPLOAD PHOTO</label>
                      <input style={{width: '80%', display: 'inline'}} type="file" className="form-control" accept="image/*" id="imageInput" name="f_name" />
                      <img src="https://www.pngall.com/wp-content/uploads/5/Profile-Male-PNG.png" className="image-preview vjk" />
                    </div>
                    )} */}
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    {role != 'agent' && (
                                 <div className="form-group frm" style={{textAlign: 'left'}}>
                                 <FormField
                                        type="text"
                                        isRequierd = {false}
                                        id="nationalID"
                                        name="nationalID"
                                        label="NATIONAL ID"
                                        placeholder = "Enter National ID"
                                        value={formData.nationalID}
                                        onChange={handleChange}
                                     
                                     />
                                 </div>
                    )}
         
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="date"
                           isRequierd = {true}
                           id="datofBirth"
                           name="datofBirth"
                           label="DATE OF BIRTH"
                           placeholder = "Enter DOB"
                           value={formData.datofBirth}
                           onChange={handleChange}
                           error={errors.datofBirth}
                           max={getCurrentDate()}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {true}
                           id="phoneNumber"
                           name="phoneNumber"
                           label="PHONE NUMBER"
                           placeholder = "Enter Phone Number"
                           value={formData.phoneNumber}
                           onChange={handleChange}
                           error={errors.phoneNumber}
                        />
                    </div>
                    {role == 'agent' && (
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <SelectField 
                                id="gender"
                                isRequierd = {true}
                                name="gender"
                                label="GENDER"
                                selectedField = "Select Gender"
                                value={formData.gender}
                                onChange={handleChange}
                                error={errors.gender}
                                options={gender}
                                />
                    </div>
                    )}
                    {/* {role == 'agent' && (
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name">UPLOAD PHOTO</label>
                      <input style={{width: '80%', display: 'inline'}} type="file" className="form-control" accept="image/*" id="imageInput" name="f_name" />
                      <img src="https://www.pngall.com/wp-content/uploads/5/Profile-Male-PNG.png" className="image-preview vjk" />
                    </div>
                    )} */}
                  </div>
                </div>
                <br />
                <div align="left">
                  <button type="submit" name="btn_admin_details" id="btn_basics_details" className="btn ddfg sebtn">Submit</button>
                </div>
                <br />
              </div>
            </div>
            </form>
          </div>
          <div className="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
            <div className="panel panel-default">
              <form onSubmit={updateAddress}>
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="col-md-12" style={{padding: 0}}>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {true}
                           id="addressLine1"
                           name="addressLine1"
                           label="ADDRESS LINE 1"
                           placeholder = "Enter Address"
                           value={formDataPersonal.addressLine1}
                           onChange={handleChangeAddress}
                           error={errors.addressLine1}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      
                      <SelectField 
                       id="state"
                       isRequierd = {true}
                       name="state"
                       label="STATE"
                       selectedField = "Select State"
                       value={formDataPersonal.state}
                       onChange={handleChangeAddress}
                       error={errors.state}
                       options={statesData}
                    />
                    
                      
                      <span id="error_profile_city" className="text-danger" />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {true}
                           id="postalCode"
                           name="postalCode"
                           label="POSTAL CODE"
                           placeholder = "Enter Postal Code"
                           value={formDataPersonal.postalCode}
                           onChange={handleChangeAddress}
                           error={errors.postalCode}
                           maxLength = {6}
                        />
                    </div>
                  
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                  <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {false}
                           id="addressLine2"
                           name="addressLine2"
                           label="ADDRESS LINE 2"
                           placeholder = "Enter Address"
                           value={formDataPersonal.addressLine2}
                           onChange={handleChangeAddress}
                           error={errors.addressLine2}
                        />
                      
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <SelectField 
                       id="city"
                       isRequierd = {true}
                       name="city"
                       label="CITY"
                       selectedField = "Select City"
                       value={formDataPersonal.city}
                       onChange={handleChangeAddress}
                       error={errors.city}
                       options={city}
                    />
                    </div>
               
                    {/* <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label className="required" htmlFor="email">POSTAL CODE</label>
                      <input type="email" className="form-control" id="profile_postal_code" placeholder="Enter Postal Code" name="email" />
                      <span id="error_profile_postal_code" className="text-danger" />
                    </div> */}
                  </div>
                </div>
                <br />
                <div align="left">
                  <button type="submit" name="btn_address_details" id="btn_address_details" className="btn ddfg sebtn">Submit</button>
                </div>
                <br />
              </div>
              </form>
            </div>
          </div>
          <div className="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
            <div className="panel panel-default">
              <form onSubmit={updatePassword}>
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="col-md-12" style={{padding: 0}}>
                  <div className="col-md-5" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                          type={showPasswordCurrent ? 'text' : 'password'}
                           isRequierd = {true}
                           id="password"
                           name="current_password"
                           label="CURRENT PASSWORD"
                           placeholder = "Enter Current Password"
                           value={setPasswordChange.current_password}
                           onChange={handleChangePassword}
                           error={errors.current_password}
                           maxLength = {20}
                        />
                        <i className={`toggle-password fa fa-fw ${showPasswordCurrent ? 'fa-eye' : 'fa-eye-slash'}`} onClick={togglePasswordVisibilityCurrent} />
                        
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                     
                      <FormField
                           type={showPassword ? 'text' : 'password'}
                           isRequierd = {true}
                           id="password"
                           name="new_password"
                           label="NEW PASSWORD"
                           placeholder = "Enter New Password"
                           value={setPasswordChange.new_password}
                           onChange={handleChangePassword}
                           error={errors.new_password}
                           maxLength = {20}
                           isPassword = {true}
                        />
                         <i className={`toggle-password fa fa-fw ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} onClick={togglePasswordVisibility} />
                         {errors.new_password && <div className="invalid-feedback">{errors.new_password}</div>}
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
              
                      <FormField
                             type={showPasswordConfirm ? 'text' : 'password'}
                           isRequierd = {true}
                           id="password"
                           name="confirm_password"
                           label="CONFIRM PASSWORD"
                           placeholder = "Enter Confirm Password"
                           value={setPasswordChange.confirm_password}
                           onChange={handleChangePassword}
                           error={errors.confirm_password}
                           maxLength = {20}
                           isPassword = {true}

                        />
                         <i className={`toggle-password fa fa-fw ${showPasswordConfirm ? 'fa-eye' : 'fa-eye-slash'}`} onClick={togglePasswordVisibilityconfirm} />
                         {errors.confirm_password && <div className="invalid-feedback">{errors.confirm_password}</div>}
                     
                    </div>
                  </div>
                </div>
                <br />
                <div align="left">
                  <button type="submit" name="btn_chngepass" id="btn_chngepass" className="btn ddfg sebtn">Submit</button>
                </div>
                <br />
              </div>
             </form>
            </div>
          </div>
        </div>
      </div>
      <Alert show={modalShow} onHide={() => logout()}  size="sm"></Alert>
    </div>
    </>
  );

}

function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(UpdateProfile));